//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
(function () {
    'use strict';

    angular
        .module('container.util')
        .factory('operatorClientStatService', operatorClientStatService);


    function operatorClientStatService($rootScope, $q, $filter, $timeout, Event, OPERATOR_CLIENT_URL, authenticationService, OperatorClientResource) {

        var service = {};
        var operatorClientCcpId;

        init();

        function init() {
            service.ocStatusService = new OperatorClientStatusService(30 * 1000, 30 * 1000);
            $timeout(() => {
                $rootScope.$emit(Event.OC_STAT_SERVICE_STARTED);
            }, 1000)
        }

        service.getOperatorClientCcpId = function () {
            var d = $q.defer();

            OperatorClientResource.get({}, function (response) {
                operatorClientCcpId = response.operatorId ? response.operatorId : undefined;

                d.resolve();
            }, function (error) {
                const errorMessage = $filter('translate')(error.data ? error.data.message : 'error while getting operator client ccp id') + ': ' + error.data ? error.data.error : '';
                console.log(errorMessage);
                d.reject();
            });

            return d.promise;
        }

        service.start = function () {
            service.ocStatusService.stop();
            if (operatorClientCcpId) {
                service.ocStatusService.start(operatorClientCcpId, authenticationService.token);
            }
        }

        $rootScope.$on(Event.OC_STAT_SERVICE_RESTART, () => {
            service.start();
        })

        return service;

    }


})();